import { ResourceMetadataKey } from "./ResourceMetadataKey";



export abstract class ResourceRequestArgs {

    abstract key: ResourceMetadataKey;
    public preserveFields: string = "metadata";

}